var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "px-0 position-relative", attrs: { fluid: "" } },
    [
      _c(
        "div",
        {
          staticClass: "position-absolute w-100 left top",
          staticStyle: { "z-index": "10" }
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "header" }, [
                _c(
                  "div",
                  { staticClass: "navigation d-flex justify-content-between" },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("a", { attrs: { href: "https://musicverse.org" } }, [
                        _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: require("@/assets/musicverse-header-logo.png")
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-nav",
                      {
                        staticClass:
                          "d-none d-md-flex justify-content-center nav-landing align-items-center",
                        attrs: { pills: "" }
                      },
                      [
                        _c(
                          "b-nav-item",
                          { attrs: { href: _vm.mv_url + "/" } },
                          [_vm._v("Home")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { href: _vm.mv_url + "/about-us/" } },
                          [_vm._v("About us")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { href: _vm.mv_url + "/musicians/" } },
                          [_vm._v("Musicians")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { href: _vm.mv_url_wp + "/blog/" } },
                          [_vm._v("Blog")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { href: "/#/donation-page" } },
                          [_vm._v("Mission Projects")]
                        ),
                        _vm._v(" "),
                        _c("b-nav-item", { attrs: { href: "/#/premium" } }, [
                          _vm._v("Premium")
                        ]),
                        _vm._v(" "),
                        _c("b-nav-item", [_vm._v("|")]),
                        _vm._v(" "),
                        _c("b-nav-item", { attrs: { href: "/#/register" } }, [
                          _vm._v("Sign Up")
                        ]),
                        _vm._v(" "),
                        _c("b-nav-item", { attrs: { href: "/#/login" } }, [
                          _vm._v("Log In")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "d-flex d-sm-none",
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none d-flex",
                          "menu-class": "bg-menu-dropdown",
                          "no-caret": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "button-content",
                            fn: function() {
                              return [
                                _c("font-awesome-icon", {
                                  staticClass: "text-white",
                                  attrs: { icon: ["fas", "bars"], size: "2x" }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "d-block d-sm-none text-white",
                            attrs: { to: "/home", "link-class": "text-white" }
                          },
                          [_vm._v("Dashboard")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              href: _vm.mv_url + "/about-us/",
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("About us")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              href: _vm.mv_url + "/musicians/",
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("Musicians")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              href: _vm.mv_url_wp + "/blog/",
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("Blog")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              href: "/#/donation-page",
                              active: _vm.isDonationPage,
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("Mission Projects")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              href: "/#/premium",
                              active: _vm.isPremiumPage,
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("Premium")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: {
                              to: "register",
                              "link-class": "text-white"
                            }
                          },
                          [_vm._v("Sign Up")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-white",
                            attrs: { to: "login", "link-class": "text-white" }
                          },
                          [_vm._v("Log In")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-carousel",
        {
          attrs: {
            id: "carousel-1",
            interval: 4000,
            fade: "",
            background: "#ababab",
            "img-width": "100vw",
            "img-height": "63%"
          }
        },
        [
          !_vm.isDonationPage && !_vm.isPremiumPage
            ? _c("b-carousel-slide", { attrs: { "img-src": _vm.bgLanding } }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column w-57 ",
                    staticStyle: { "padding-bottom": "8%" }
                  },
                  [
                    _c("span", { staticClass: "slider-title text-left" }, [
                      _vm._v("Login or Register")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "slider-image-topup" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/phone-slider.png") }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isDonationPage
            ? _c(
                "b-carousel-slide",
                { attrs: { "img-src": _vm.bgDonationsSlider } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column w-51 ",
                      staticStyle: { "padding-bottom": "8%" }
                    },
                    [
                      _c("span", { staticClass: "slider-title text-left" }, [
                        _vm._v("Missions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "text-left",
                          staticStyle: { "margin-bottom": "4px" }
                        },
                        [_vm._v("Donate to MusicVerse to support missions")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-left" }, [
                        _vm._v(
                          "MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors"
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPremiumPage
            ? _c(
                "b-carousel-slide",
                { attrs: { "img-src": _vm.bgSubscribeSlider } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column w-57 ",
                      staticStyle: { "padding-bottom": "8%" }
                    },
                    [
                      _c("span", { staticClass: "slider-title text-left" }, [
                        _vm._v("Go Premium for as low as $1!")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-left" }, [
                        _vm._v(
                          "Enjoy listening to songs in full, listen to songs offline, and share to missions. Cancel anytime!"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c(
                          "a",
                          {
                            staticClass: "learn-more ",
                            staticStyle: { width: "210px", cursor: "pointer" },
                            attrs: { align: "center" },
                            on: {
                              click: function($event) {
                                return _vm.gotToRoute("subscribe")
                              }
                            }
                          },
                          [_vm._v("Go Premium")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "slider-image-subscribe" }, [
                    _c("img", {
                      attrs: { src: require("@/assets/person-subscribe.png") }
                    })
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b0e146c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b0e146c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderLanding.vue
// module id = null
// module chunks = 